module.exports = __webpack_public_path__ + "static/img/1-13.c0f3c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/1-13.png
// module id = bgHh
// module chunks = 15